import { render, staticRenderFns } from "./CreateGovermentRotaOrder.vue?vue&type=template&id=2fe36b32"
import script from "./CreateGovermentRotaOrder.vue?vue&type=script&lang=js"
export * from "./CreateGovermentRotaOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports